/**
 * 图片上传请求封装
 * @author 棠棣
 * @since  2020-06-12 17:14:16
 */
import { baseURL as ossURL } from '@/config';
import Axios from 'axios';
import { parseXML } from './func';
/**
 * 获取OSS签名
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-03 00:06:57
 */
export const getSignature = async () => Axios.get(`${ossURL}/api/v1/oss-token/`, {});
let accessid = '';
let policyBase64 = '';
let signature = '';
let key = '';
let expire = 0;
let host = '';
let gObjectName = '';
let now = Date.now();
// 生成随机字符串
function randomString(len) {
    len = len || 32;
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const maxPos = chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}
// 获取用户上传原始文件名
function getFileName(filename) {
    const pos = filename.lastIndexOf('.');
    let suffix = '';
    if (pos != -1) {
        suffix = filename.substring(pos);
    }
    return suffix;
}
//  把随机生成的字符串拼接在原始上传文件名后面生成新的唯一文件名
function setFileName(filename) {
    const suffix = getFileName(filename);
    gObjectName = key + randomString(18) + suffix;
    return '';
}
// 获取后端返回的签名信息，生成oss参数
export const ossRequest = async (filename) => {
    // 可以判断当前expire是否超过了当前时间， 如果超过了当前时间， 就重新取一下， 3 s 作为缓冲。
    now = Date.now();
    if (expire < now + 3000) {
        // 调用后端服务器接口获取签名信息，利用axios返回promise，可以链式调用
        const res = await getSignature();
        const ossInfo = res.data.data;
        policyBase64 = ossInfo['policy'];
        accessid = ossInfo['accessid'];
        signature = ossInfo['signature'];
        expire = ossInfo['expire'];
        host = ossInfo['host'];
        key = ossInfo['dir'];
        if (filename !== null) {
            setFileName(filename);
        }
    }
    return Promise.resolve({
        host,
        key: gObjectName,
        policy: policyBase64,
        OSSAccessKeyId: accessid,
        signature: signature,
        success_action_status: 201,
    });
};
/**
 * 转储网络图片到OSS
 * 开局一个网址，剩下全靠浏览器
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-03 10:50:32
 * @param {string} url 远程图片地址
 */
export const saveNetImageToOss = async (url) => {
    const filename = url.replace(/.+(?=\/)\//g, '');
    const response = await fetch(url);
    const blob = await response.blob();
    const res = await ossRequest(filename);
    const { host, key, policy, OSSAccessKeyId, signature, success_action_status } = res;
    const formData = new FormData();
    formData.append('host', host);
    formData.append('key', key);
    formData.append('policy', policy);
    formData.append('OSSAccessKeyId', OSSAccessKeyId);
    formData.append('signature', signature);
    formData.append('success_action_status', `${success_action_status}`);
    formData.append('file', blob);
    return Axios.post(res.host, formData);
};
export const uploadImage = async (file) => {
    const res = await ossRequest(file.name);
    const { host, key, policy, OSSAccessKeyId, signature, success_action_status } = res;
    const formData = new FormData();
    formData.append('host', host);
    formData.append('key', key);
    formData.append('policy', policy);
    formData.append('OSSAccessKeyId', OSSAccessKeyId);
    formData.append('signature', signature);
    formData.append('success_action_status', `${success_action_status}`);
    formData.append('file', file);
    return Axios.post(res.host, formData);
};
/**
 * 解析OSS存储返回XML
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-05 23:30:48
 */
export const parseOSSResponse = (responseStr) => {
    const xmlDom = parseXML(responseStr);
    return xmlDom?.children[0]?.children[1]?.textContent ?? '';
};
/**
 * 保存远程图片
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-05 23:31:03
 */
export const saveNetImage = async (url) => {
    const response = await saveNetImageToOss(url);
    return parseOSSResponse(response.data);
};
/**
 * 从网络读取图片的base64
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-07-23 17:33:27
 */
export const getNetImageBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const data = await new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    });
    return data;
};
//# sourceMappingURL=upload.js.map